<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/fact-in-call/feature/summary.jpg'"
        :altText="`工場でも活躍の呼出しチャイム ファクトインコール`"
        :headerText="
          `よりスピーディーな対応を可能に！ファクトインコールは呼び出しを
          確実に伝えるコードレス・チャイム・システムです。`
        "
        :detailText="
          `少人数スタッフで効率よく対応することを可能にするファクトインコール。設置された送信機の呼び出しボタンをプッシュすれば、
          その信号を受信表示機がキャッチして、表示機や音でお知らせします。`
        "
        :color="'blue'"
      />

      <h2>他の追随を許さない、ファクトインコールならではの 8 つの機能。</h2>

      <div class="feature-contents functions">
        <div class="feature-content">
          <content-header
            headingTitle="1"
            headingTitleRadius="0"
            smallTitle="トラブル情報を PC で"
            title="データ管理機能"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <h4>トラブルの発生回数等を把握できます。</h4>
          <p>
            受信表示機（スタンダード型）とPCをRS232C接続することで、ファクトインコールの稼働状況データをPCで管理することが可能。
          </p>
          <p>
            トラブル発生の回数や時間帯等を把握できます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="2"
            headingTitleRadius="0"
            smallTitle="3 色 LED による"
            title="色分け表示"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <h4>トラブル別に表示色を設定できます。</h4>
          <p>
            赤・黄・緑の3色番号表示に対応（受信表示機）。赤は部品切れ、黄は動作不良など内容によって表示色を変更することが可能。
          </p>
          <p>
            表示色を見るだけでトラブル内容を把握することが可能になります。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="3"
            headingTitleRadius="0"
            smallTitle="広いエリアでの活用が可能"
            title="特定小電力タイプ"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <h4>携帯受信表示機と中継機もラインナップ。</h4>
          <p>
            「特定小電力」ならではの広エリア対応を実現。フォークリフトのドライバーが携帯受信表示機を持ち、移動しながら呼び出しを受信できます。また中継機の利用で、より広エリアや入り組んだ施設内の通信にも対応します。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="4"
            headingTitleRadius="0"
            smallTitle="的確な対応を可能にする"
            title="先着順番号表示"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <h4>先に呼ばれた場所から対応できます。</h4>
          <p>
            ディスプレイ部には先着順に送信機番号を表示。
          </p>
          <p>
            呼び出された順番が一目でわかります。そのため対応する順番を誤ることがありません。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="5"
            headingTitleRadius="0"
            smallTitle="パトライト、外部スピーカーと連携"
            title="外部出力機能"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <h4>トラブル発生をよりわかりやすく伝えます。</h4>
          <p>
            受信表示機（スタンダード型）は、パトライトや外部スピーカーと接続することも可能。受信表示機がかなり離れた場所にあったり、騒音が気になる場所に設置されていても、トラブル発生をタイムリーに把握できます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="6"
            headingTitleRadius="0"
            smallTitle="呼び出し番号の"
            title="残数を表示"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <h4>呼び出し数が多くても安心です。</h4>
          <p>
            5件以上の呼び出しはメモリ内に96件まで記録。件数をサブディスプレイに表示（表示されている呼び出し番号件数を含む）します。
          </p>
          <p>
            ディスプレイ部の番号を消去すると、番号を順次表示します。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="7"
            headingTitleRadius="0"
            smallTitle="自動運転機器に最適"
            title="信号入力型送信機"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <h4>トラブル発生を自動でお知らせします。</h4>
          <p>
            信号入力型送信機をラインナップ。自動運転機器と接続することで、トラブル発生時に自動で信号を送信。管理者が操作しなくてもトラブル発生を知らせます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="8"
            headingTitleRadius="0"
            smallTitle="経過時間によって"
            title="番号表示が変化"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <h4>「対応忘れ」を予防します。</h4>
          <p>
            表示されている呼び出し番号は、一定時間が経過すると点滅表示となります。しかも時間経過に伴い点滅するスピードが4段階で変化するため、「対応遅れ」を予防することが可能です。
          </p>
        </div>
      </div>

      <h2>スマート & スムーズな対応を可能にします。</h2>
      <div class="feature-contents features">
        <div class="feature-content">
          <content-header
            title="2 ボタン型・送信機"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            withoutUnderline="false"
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_01.png'"
          />
          <p>
            送信機のバリエーションとして「２つボタン型」をラインナップ。例えば、片方のボタンを（スタッフ通常呼出し）に、もう片方のボタンを（スタッフ緊急呼出し）に設定しておけば、状況に応じた速やかな対応が可能になります。
          </p>
          <p>
            また、どちらからのボタンを（番号消去）に設定すれば、消去＆設定機を使用しなくても、受信表示機の番号を消去できます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="エリア毎にチャイム音を設定"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            withoutUnderline="false"
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_02.png'"
          />
          <p>
            ファクトインコールは、送信機毎にチャイム音を設定することが可能（13種類の中から1つのチャイム音）。
          </p>
          <p>
            窓側の席はチャイム音1、廊下側はチャイム音2など、エリア別にチャイム音を設定しておけば、音を聞くだけで、どのエリアから呼び出されているかがわかり、素早く、そして効率よく対応することが可能になります。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="呼び出された番号がひと目でわかる"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            withoutUnderline="false"
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_03.png'"
          />
          <p>
            受信表示機のディスプレイ部には、先着順に呼び出し番号を表示（5件）先に呼ばれたのがどの番号だったのかで悩む心配がありません。
          </p>
          <p>
            5件以上の呼び出しが同時にあった場合でも、受信表示機内のメモリに96件までそれを記録し、件数をサブディスプレイ部に表示します。ディスプレイ部の番号を消去すると、連動して記録している呼び出し番号を読み込み先着順にディスプレイ部に表示します。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="1 階と 2 階などでも使用 OK"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            withoutUnderline="false"
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_04.png'"
          />
          <p>
            これまでのコードレシステムが苦手としていた、送信機と受信機がかなり離れいるようなケースや、店内がＬ字型になっているケース、建物の１階と２階で使用したいというケース等でも、ファクトインコールなら大丈夫。
          </p>
          <p>
            中継機を使用することで安定した通信が行えるようになるため、いつでも安心してご利用いただけます。ファクトインコールは、店舗のカタチを選ばない、快適そしてフレキシブルなシステムです。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="移動中でも呼び出し受信可能"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            withoutUnderline="false"
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_05.png'"
          />
          <p>
            携帯電話サイズの携帯受信表示機をラインナップ。離れた場所や移動中でも呼び出しを受けることが可能になりました。
          </p>
          <p>
            スタッフが常に携帯受信表示機を携帯することで、よりタイムリーな対応が行なえます。標準型の受信機を利用せず、携帯受信表示機と送信機を組み合わせて使うコンパクトでコストパフォーマンスの高いシステムもおすすめです。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="赤・黃・緑の 3 色表示"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            withoutUnderline="false"
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_06.png'"
          />
          <p>
            ファクトインコールなら、呼出し番号を３色のLEDで色分け表示できます。テーブルのアリアごとにカラー設定すれば、効率よく接客することが可能になります。例えば「カウンター席を赤色、一般のテーブル席を黄色、個室を緑色で表示する」というように設定することで、スタッフが素早く、そしてスムーズに呼び出されたテーブル、エリアが見つけられます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="席数の多いお店でも安心"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            withoutUnderline="false"
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_07.png'"
          />
          <p>
            呼び出し番号を３色のLEDで色分け表示（各色１～FF番まで）できます。テーブルのエリアごとに色を設定すれば、効率よく接客することが可能になります。例えば「カウンター席を赤色・1～30番、一般のテーブル席を黄色・31～60番、個室を緑色・60～99番で表示」と設定することで、素早くスムーズに呼び出されたテーブルエリアを見つけられます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="時間経過を点滅でお知らせ"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            withoutUnderline="false"
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_08.png'"
          />
          <p>
            受信表示機のディスプレイ部に表示されている呼び出し番号は、一定の時間が経過すると点滅表示となります。しかも時間経過に伴い、点滅速度は４段階で変化します。（点灯→点滅（遅い点滅）→点滅（早い点滅）→フリッカ（高速点滅）。お客様をどのくらいお待たせしているのかが一目で判断できるので大変便利です。
          </p>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">利用シーン</h2>
        </div>
      </div>

      <div class="use-scene">
        <div class="header">
          <h3>さまざまなシーンでご活用いただけるファクトインコール</h3>
        </div>
        <div class="body">
          <div class="use-scene-block">
            <img
              v-lazy="'/static/products/fact-in-call/feature/scene_01.jpg'"
            />
            <h4>トラブル発生を速やかに。</h4>
            <p>
              問題が発生したら、即座にコール！工場ラインの安定稼働・大幅な省力化を実現します。
            </p>
            <link-button
              v-bind:link="`/choice/industry/3`"
              v-bind:title="`こちらのシーンにマッチする商品を見る`"
            />
          </div>
          <div class="use-scene-block">
            <img
              v-lazy="'/static/products/fact-in-call/feature/scene_02.jpg'"
            />
            <h4>LL 教室でのやりとりに。</h4>
            <p>
              オーディオやビデオ、コンピュータなどの機器を活用しながらの授業中でも、生徒と先生間のコミュニケーションをサポートします。
            </p>
            <link-button
              v-bind:link="`/choice/industry/12`"
              v-bind:title="`こちらのシーンにマッチする商品を見る`"
            />
          </div>
          <div class="use-scene-block">
            <img
              v-lazy="'/static/products/fact-in-call/feature/scene_03.jpg'"
            />
            <h4>
              持ち歩けるナースコールとして。
              <span style="font-size: 12px; vertical-align: top;">※</span>
            </h4>
            <p>
              ナースコールのワイヤレス化を実現。離れた場所にいる看護婦さんに、コールをワンタッチで知らせることができます。
            </p>
            <link-button
              v-bind:link="`/choice/industry/4`"
              v-bind:title="`こちらのシーンにマッチする商品を見る`"
            />
          </div>
          <div class="use-scene-block">
            <img
              v-lazy="'/static/products/fact-in-call/feature/scene_04.jpg'"
            />
            <h4>
              無線のナースコールとして。
              <span style="font-size: 12px; vertical-align: top;">※</span>
            </h4>
            <p>
              困った時や来て欲しい時など、いつでも無線で介護スタッフ宛に届きます。
            </p>
            <link-button
              v-bind:link="`/choice/industry/5`"
              v-bind:title="`こちらのシーンにマッチする商品を見る`"
            />
          </div>
        </div>
        <div style="font-size: 12px; text-align: right; margin: 20px 15% 0">
          ※本商品は報知および連絡用です。生命救済、犯罪防止を目的にした機器ではありません。
        </div>
      </div>
    </div>

    <div class="feature-middle">
      <div class="feature-contents">
        <div class="feature-content">
          <content-header
            title="耐ノイズ・広エリアを実現"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            特定小電力だから広エリア・耐ノイズを実現。一般の無線を使用する場合よりもノイズが少ないため、混線などの心配がさらに少なくなりました。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="さらに広い場所でもご利用いただける中継機もご用意"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            style="width: 75%;"
          />
          <p>
            ファクトインコールは、そのまま使用しても広いエリアをカバーしますが、中継機を活用することで、
          </p>
          <p>
            より広いエリアや複雑に入り組んだ施設内でも安心して通信を行うことができます。
          </p>
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_09.png'"
            style="width: 20%; height: auto;"
          />
        </div>
        <div class="feature-content">
          <content-header
            title="従来の表示機能を携帯サイズに凝縮した携帯受信表示機"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            style="width: 75%;"
          />
          <p>
            受信表示機の高性能はそのままに、携帯できるコンパクトサイズを実現。
          </p>
          <p>
            スタッフが携帯することで、よりスムーズに、そしてより効率の良い対応が行なえます。
          </p>
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_10.png'"
            style="width: 20%; height: auto;"
          />
          <div style="display: flex; justify-content: space-between;">
            <img
              v-lazy="'/static/products/fact-in-call/feature/feature_11.png'"
              style="position: static; width: 15%; height: 100%; margin-right: 20px;"
            />
            <div>
              <div>
                <h4>使いやすく見やすい 2 窓表示</h4>
                <p>
                  2箇所からの呼び出しを表示します。それ以上の呼び出しがあった場合は、メモリに記憶して順次繰り上がり表示します。
                </p>
              </div>
              <div>
                <h4>振動で伝わるバイブレーション機能</h4>
                <p>
                  呼び出し受信時には、サウンドとバイブレーション（振動）でお知らせ。イヤホンも取り付けられるため、トラブル発生を確実に把握できます。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="feature-content">
          <content-header
            title="可動状況を PC でデータ管理したりパトライト、外部スピーカーと接続可能です。"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            トラブル発生を速やかに表示。PCへのデータ出力やパトライト等との連携も実現し、工場などではラインの安定稼働・大幅な省力化を実現します。
          </p>
          <img
            v-lazy="'/static/products/fact-in-call/feature/feature_12.jpg'"
            style="display: block; margin: 20px auto; position: static; width: 90%; max-width: 600px; height: auto;"
          />
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">トラブル<br />解決例</h2>
        </div>
      </div>

      <div class="solution-example">
        <div class="header">
          <h3>トラブルに素早く対応することで生産ラインの稼働効率向上を実現</h3>
        </div>
        <div class="body">
          <img
            v-lazy="'/static/products/fact-in-call/feature/example_01.png'"
            @click="
              ;(showModal = true),
                (modalImage =
                  '/static/products/fact-in-call/feature/example_large_01.png')
            "
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/example_02.png'"
            @click="
              ;(showModal = true),
                (modalImage =
                  '/static/products/fact-in-call/feature/example_large_02.png')
            "
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/example_03.png'"
            @click="
              ;(showModal = true),
                (modalImage =
                  '/static/products/fact-in-call/feature/example_large_03.png')
            "
          />
          <img
            v-lazy="'/static/products/fact-in-call/feature/example_04.png'"
            @click="
              ;(showModal = true),
                (modalImage =
                  '/static/products/fact-in-call/feature/example_large_04.png')
            "
          />
        </div>
        <div style="font-size: 13px;">
          ▲各事例はクリックで拡大できます。
        </div>
      </div>
      <image-modal v-if="showModal" @close="showModal = false">
        <div slot="body">
          <img v-lazy="modalImage" />
        </div>
      </image-modal>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">主な機能</h2>
        </div>
      </div>

      <div class="main-function blue">
        <div class="body">
          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">受信表示機 3色表示</h3>
              <div class="product-detail">
                <p>3色LED表示による確かな表現力。</p>
                <p>視認性、そして設置性を追究した新設計筐体を採用</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/fact-in-call/feature/function_01.jpg'"
            />
            <div class="function">
              <div class="function-title">
                3色LEDによる色分け表示
              </div>
              <div class="function-detail">
                赤・黄・緑の 3 色番号表示に対応。赤は部品切れなど色毎に<br />
                トラブル内容をあらかじめ設定しておくことで、速やかにトラブルの<br />
                内容を把握できます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                先着順番号表示
              </div>
              <div class="function-detail">
                先着順に左から送信機の番号を表示します。呼び出された順番が<br />
                ひと目でわかるため、対応する順番を間違える心配がありません。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                呼び出しの残数を表示
              </div>
              <div class="function-detail">
                5 件以上の呼び出しはメモリ内に 96
                件まで記録。件数をサブディス<br />
                プレイに表示（表示されている呼び出し番号件数を含む）します。
              </div>
            </div>

            <div class="product-tips">
              <div class="product-tip">
                <img
                  v-lazy="
                    '/static/products/fact-in-call/feature/function_02.jpg'
                  "
                />
                <p>
                  受信表示機とPCをRS232C接続し、PC側で専用ソフトを利用することで、稼働状況を管理できます。
                </p>
              </div>
              <div class="product-tip">
                <img
                  v-lazy="
                    '/static/products/fact-in-call/feature/function_03.jpg'
                  "
                />
                <p>
                  パトライトや外部スピーカーとの接続にも対応。トラブルの発生をよりわかりやすく伝えます。
                </p>
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">携帯受信表示機 & 充電器</h3>
              <div class="product-detail">
                <p>持ちやすさと、操作しやすさを両立。</p>
                <p>見やすさにもこだわった、携帯タイプの受信表示機。</p>
              </div>
            </div>
            <div style="text-align: center;">
              <img
                class="product-image"
                v-lazy="'/static/products/fact-in-call/feature/function_04.jpg'"
                style="display: inline-block;"
              />
              <img
                class="product-image"
                v-lazy="'/static/products/fact-in-call/feature/function_05.jpg'"
                style="display: inline-block;"
              />
            </div>
            <div class="function">
              <div class="function-title">
                4つのスタイルで呼び出しをお知らせ
              </div>
              <div class="function-detail">
                受信ランプ・チャイム音・バイブレーション・番号表示の4スタイル<br />
                で、送信機からの呼び出しを確実に伝えます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                新型ニッケル水素電池採用
              </div>
              <div class="function-detail">
                リチウムイオンポリマー充電池を採用し、バッテリロングライフ設計を実施。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                連続待受け30時間＆約6時間でフル充電
              </div>
              <div class="function-detail">
                連続待受時間 30時間※を実現。携帯受信表示機のフル充電に掛かる<br />
                時間は約 6 時間。充電をまとめて開始 / 停止できる、<br />
                一括集中スイッチも装備しています。<br />
                <span style="font-size: 10px;">
                  ※連続待受時間は、電波を正常に受信できる静止状態での平均的な利用時間です。<br />
                  充電状態・気温などの使用環境、利用場所の電波状態などによっては、ご利用時間が<br />
                  短くなることがあります。
                </span>
              </div>
            </div>

            <div class="product-tips">
              <div class="product-tip">
                <img
                  v-lazy="
                    '/static/products/fact-in-call/feature/function_06.jpg'
                  "
                />
                <p>
                  チャイム音を聞き取りにくい場所での活用を容易にするイヤホンを標準で添付。またネックストラップも標準添付しています。別途購入する必要がありません。
                </p>
              </div>
              <div class="product-tip">
                <img
                  v-lazy="
                    '/static/products/fact-in-call/feature/function_07.jpg'
                  "
                />
                <p>
                  充電器の携帯受信表示機収納スペースは、ワンタッチで取り外すことが可能。簡単に清掃できるため、ホコリによる充電不良等のトラブルがなくなります。
                </p>
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">送信機</h3>
              <div class="product-detail">
                <p>トラブルをワンタッチで</p>
                <p>受信表示機/携帯受信表示機へ送信します。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/fact-in-call/feature/function_08.jpg'"
            />
            <div class="function">
              <div class="function-title">
                スタンダード型
                <span
                  style="color: #4d4d4d; font-size: 14px; margin-left: 5px;"
                >
                  2種類の信号を受信表示機へ送信可能。
                </span>
              </div>
              <div class="function-detail">
                例えば「部品切れ」と「機械故障」を設定しておけば、受信表示機<br />
                を見るだけでどちらのトラブルが発生したのかがわかります。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                ナプキンスタンド型
                <span
                  style="color: #4d4d4d; font-size: 14px; margin-left: 5px;"
                >
                  テーブルスペースを無駄なく活用可能。
                </span>
              </div>
              <div class="function-detail">
                スタンダード型送信機とナプキンスタンドがドッキング。<br />
                使い勝手に優れた、飲食店で人気のモデルです。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                カード型
                <span
                  style="color: #4d4d4d; font-size: 14px; margin-left: 5px;"
                >
                  使用場所を選ばないコンパクト設計。
                </span>
              </div>
              <div
                class="function-detail"
                style="width: 55%; display: inline-block;"
              >
                テーブルの上はもちろん、<br />
                壁などに取り付けても使用できる、<br />
                便利なカードタイプの送信機も<br />
                ラインナップしています。
              </div>
              <img
                v-lazy="'/static/products/fact-in-call/feature/function_09.png'"
                style="width: 45%; float: right; padding-top: 10px;"
              />
            </div>
            <div class="function">
              <div class="function-title">
                信号入力型
                <span
                  style="color: #4d4d4d; font-size: 14px; margin-left: 5px;"
                >
                  無人運転機器のトラブルに対応。
                </span>
              </div>
              <div class="function-detail">
                トラブルが発生した場合に、信号を受信表示機へ自動送信。管理者が<br />
                操作しなくても、トラブルの発生を知らせます。
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">中継機</h3>
              <div class="product-detail">
                <p>ファクトインコールの</p>
                <p>通信範囲をさらに拡大する先進の中継機。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/fact-in-call/feature/function_10.jpg'"
            />
            <div class="function">
              <div class="function-title">
                信号の到達範囲を拡大。
              </div>
              <div class="function-detail">
                中継機の利用で、信号の到達範囲を拡大することが可能。<br />
                より広い場所で、ご利用いただくことが可能になります。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                受信電波強度表示機能を搭載。
              </div>
              <div class="function-detail">
                受信電波強度を LED で表示。<br />
                電波が届いている / いないがひと目でわかるので大変便利です。<br />
                MAX60 で 20 以上あれば確実に受信できます。
              </div>
            </div>
            <div style="margin: 10px 0 0; display: table; height: 100px;">
              <img
                v-lazy="'/static/products/fact-in-call/feature/function_13.jpg'"
                style="width: 90%; border: 1px solid rgb(199, 199, 199);"
              />
              <span
                style="display: table-cell; vertical-align:top; font-size: 13px; padding-top: 20px; width: 50%;"
              >
                軽量＆コンパクトだから<br />
                設置場所は自由自在。<br />
                専用取付金具もご用意（別売）
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading">
          <h2 class="circle-heading-title">使用例</h2>
        </div>
      </div>
      <div class="header">
        <h3>
          離れた場所や移動中のスタッフの呼出しに
        </h3>
      </div>
      <img
        style="width: 100%;max-width: 850px;"
        src="/static/products/fact-in-call/usage-example.png"
        alt="離れた場所や移動中のスタッフの呼出しに"
      />
      <p class="cta-microcopy" style="margin-top: 2.5rem">
        ＼この使い方にピンときた方へ／
      </p>
      <div
        class="column_wrap_cta"
        style="background: none; padding: 0; margin-bottom: 3.5rem"
      >
        <a class="column_wrap_cta_contact" href="/contact"
          >無料見積もり・お問い合わせはこちら</a
        >
      </div>
    </div>

    <div class="feature-section worry">
      <div class="circle-parent">
        <div class="circle-heading">
          <h2 class="circle-heading-title">お悩み<br />コンテンツ</h2>
        </div>
      </div>
    </div>
    <div class="worries-column" style="margin-bottom: 6%;">
      <div class="use-scene-block">
        <router-link to="/column/56">
          <div class="use-scene-block-header">
            店員が捕まらず購入を諦めるお客様がいるなら呼び出しベルの導入を
          </div>
        </router-link>
        <p>
          呼び出しベルには工事不要で設置できる製品も多く、お客様がスタッフを呼び出す以外にも、サービスの順番待ちをしているお客様の呼び出しにも活用できます。ホームセンターや家電量販店に向いた呼び出しベルについて解説します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/48">
          <div class="use-scene-block-header">
            医師・看護師がどこにいるのか分からないなら呼び出しベルがおすすめ
          </div>
        </router-link>
        <p>
          医師や看護師がどこにいるのか分からず、探すのに無駄な時間がかかっている場合、呼び出しベルの導入で業務を効率化できます。病院・クリニック向きの呼び出しベルを紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/39">
          <div class="use-scene-block-header">
            無人運転中の機械トラブルに気付けない！呼び出しベルでお悩み解決
          </div>
        </router-link>
        <p>
          当記事では、無人運転中の機械トラブルに気付けない問題に直面している方に向けて、呼び出しベルを導入するメリットやおすすめの呼び出しベルを3つ紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/37">
          <div class="use-scene-block-header">
            '作業中の呼び出しに気付けない！工場の悩みを解決できる呼び出しベル
          </div>
        </router-link>
        <p>
          当記事では、工場勤務で「作業中の呼び出しに気付けない」という悩みを抱えている方に向けて、作業中の呼び出しに気付きにくい理由や解決方法を解説します。
        </p>
      </div>
    </div>

    <div class="feature-section" id="spec">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">仕様</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <specs v-bind:useType="useType" v-bind:items="items" />
        </div>
      </div>
    </div>

    <div class="feature-section" id="price">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">価格</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <prices
            v-bind:items="
              items.filter(function(item) {
                return (
                  (item.listPrice > 0 && item.regularPrice > 0) ||
                  item.openPrice > 0 ||
                  item.summaryImagePath
                )
              })
            "
          />
        </div>
      </div>
    </div>

    <div class="feature-section" id="catalogue">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">カタログ</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <catalogues
            v-bind:useType="useType"
            v-bind:productName="productName"
            v-bind:items="catalogues"
            v-bind:appDownloadUrl="appDownloadUrl"
          />
        </div>
      </div>
    </div>

    <div class="product_question">
      <h2 style="color: #0a518d">よくある質問</h2>
      <question-and-answer
        :number="1"
        :question="'送信機からの呼出しを離れた場所でも確認できますか？'"
        :answer="
          `携帯電話サイズの携帯受信表示機をラインナップ。離れた場所や移動中でも呼び出しを受けることが可能になりました。スタッフが常に携帯受信表示機を携帯することで、よりタイムリーな対応が行なえます。`
        "
      />
      <question-and-answer
        :number="2"
        :question="'どの送信機から呼び出しがあったのか解りますか？'"
        :answer="
          `受信表示機のディスプレイには、呼び出した送信機の番号を先着順で表示します。また、3色LEDによる赤・黄・緑の 3 色番号表示に対応。赤は部品切れなど色毎にトラブル内容やエリアごとにカラーを設定しておくことで、速やかに内容を把握できます。`
        "
      />
      <question-and-answer
        :number="3"
        :question="'無人運転システムのトラブルを自動で送信できますか？'"
        :answer="
          `無電圧接点タイプと電圧入力タイプの2種類の信号入力型送信機で無人運転機器のトラブルに対応。トラブルが発生した場合に、信号を受信表示機へ自動送信することが出来ます。管理者が操作しなくても、自動でトラブルの発生を知らせます。`
        "
      />
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/4" target="_blank"
            ><img
              src="/static/columns/15/hospital_mv.png"
              alt="病院・薬局の呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/4" target="_blank"
              >病院・薬局の呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/9" target="_blank"
            ><img
              src="/static/columns/9/img_about_andon1.jpg"
              alt="アンドンとは？生産ラインで重視される理由や種類・運用のポイントも"
          /></a>

          <h3>
            <a href="/column/9" target="_blank"
              >アンドンとは？生産ラインで重視される理由や種類・運用のポイントも</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/10" target="_blank"
            ><img
              src="/static/columns/10/img_wirelesschime_cannot_ring1.jpg"
              alt="ワイヤレスチャイムが鳴らない5つの理由｜トラブルの少ない機種も"
          /></a>

          <h3>
            <a href="/column/10" target="_blank"
              >ワイヤレスチャイムが鳴らない5つの理由｜トラブルの少ない機種も</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'
import ImageModal from '@/components/modules/products/features/ImageModal'
import Specs from '@/components/modules/Specs'
import Prices from '@/components/modules/Prices'
import Catalogues from '@/components/modules/Catalogues'
import QuestionAndAnswer from '@/components/modules/QuestionAndAnswer'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
    ImageModal,
    Specs,
    Prices,
    Catalogues,
    QuestionAndAnswer,
  },
  data: function() {
    return {
      showModal: false,
      modalImage: '',
      productName: 'fact-in-call',
      useType: 2,
      items: [
        {
          name: '受信表示機 3色表示',
          imagePath: '/static/products/fact-in-call/items/item_01.png',
          spec: {
            型式: 'F-100',
            サイズ: '550（W）×55（D）×13（H）mm',
            重量: '約 1,350g（コード含む）',
            電源: 'AC100V',
            消費電力: '約 15W',
            受信周波数: '426.025MHz ～（特定小電力）',
            受信方式: '単信方式',
            受信距離: '約 100m（使用環境により変わります）',
            表示方式: `2 桁 5 窓 着信順 3 色表示
            設定番号及び コール残数表示`,
            チャイム音: '13 種類ロータリー設定',
            音量調節: '16 段階',
            スピーカー出力: '300mW',
            'LED 輝度調節': '16 段階',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          priceName: `受信表示機 3 色表示（F-100)`,
          listPrice: 220000,
          regularPrice: 154000,
        },
        {
          name: '消去機＆設定機',
          imagePath: '/static/products/fact-in-call/items/item_02.png',
          spec: {
            型式: 'F-400',
            サイズ: '245（W）×80（D）×25（H）mm',
            重量: '約 230g（単三アルカリ乾電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送受信周波数: '426.025MHz ～（特定小電力）',
            送受信方式: '単信方式',
            送信出力: '1mW',
            送信時動作: '5kHz の電子音（ピッ）',
            設定: '音量・表示輝度・自動消去時間・音色',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          priceName: `消去 & 設定器機 5 窓対応
          （F-400)`,
          listPrice: 30000,
          regularPrice: 21000,
        },
        {
          name: '携帯受信表示機',
          imagePath: '/static/products/fact-in-call/items/item_03.png',
          spec: {
            型式: 'F-200',
            サイズ: '51（W）×129（D）×21（H）mm',
            重量: '110g（電池パック含む）',
            電源: '充電バッテリー（リチウムイオンポリマー）',
            送信周波数: '426.025MHz ～（特定小電力）',
            送受信方式: '単信方式',
            '送信出力（消去時）': '1mW',
            送信時動作: '5kHz の電子音（ピッ）',
            表示方式: '2 桁 2 窓　着信順 3 色表示',
            メモリ記憶数: '50 件',
            充電時間: '約 6 時間',
            待受時間: '約 30 時間（使用環境により変わります）',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          priceName: `携帯受信表示機（F-200)
          専用ストラップ・イヤホン付
          カラー：メタリック、ブラック`,
          listPrice: 45000,
          regularPrice: 31500,
        },
        {
          name: '充電器 5台用',
          imagePath: '/static/products/fact-in-call/items/item_04.png',
          spec: {
            型式: 'F-705',
            サイズ: '79（W）×165（D）×54（H）mm',
            重量: '約 400g',
            電源: 'DC6V 専用アダプター',
            充電時間: '約 6 時間',
            充電方式: '接点充電',
            セパレーツ式: '収納部セパレート方式（掃除可能）',
            消費電力: '約 12W（ピーク時）',
          },
          priceName: `充電器 5 台タイプ（F-705）`,
          listPrice: 25000,
          regularPrice: 17500,
        },
        {
          name: '充電器 10台用',
          imagePath: '/static/products/fact-in-call/items/item_05.png',
          spec: {
            型式: 'F-710',
            サイズ: '79（W）×290（D）×54（H）mm',
            重量: '約 550g',
            電源: 'DC6V 専用アダプター',
            充電時間: '約 6 時間',
            充電方式: '接点充電',
            セパレーツ式: '収納部セパレート方式（掃除可能）',
            消費電力: '約 24W（ピーク時）',
          },
          priceName: `充電器 10 台タイプ（F-710）`,
          listPrice: 30000,
          regularPrice: 21000,
        },
        {
          name: '無電圧入力送信機',
          imagePath: '/static/products/fact-in-call/items/item_06.png',
          spec: {
            型式: 'F-304',
            サイズ: `75（W）×36.9（D）×116（H）mm
            ホルダー装着時
            75.42（W）×42.1（D）×116.42（H）mm`,
            重量: `約 165g（単三アルカリ電池 ×2 本含む。
            ホルダー装着時は約 190g）`,
            電源: `単三アルカリ電池 ×2 本
            DC3.3V 専用アダプター（別売）`,
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1 ～ FF',
            表示色設定: '色分け可能',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。`,
          priceName: `送信機 無電圧入力型（F-304)
          カラー：グレー`,
          listPrice: 12000,
          regularPrice: 8400,
        },
        {
          name: '電圧入力型送信機（１入力）',
          imagePath: '/static/products/fact-in-call/items/item_06.png',
          spec: {
            型式: 'F-306',
            サイズ: `75（W）×36.9（D）×116（H）mm
            ホルダー装着時
            75.42（W）×42.1（D）×116.42（H）mm`,
            重量: `約 165g（単三アルカリ電池 ×2 本含む。
            ホルダー装着時は約 190g）`,
            電源: `単三アルカリ電池 ×2 本
            DC3.3V 専用アダプター（別売）`,
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1 ～ FF',
            表示色設定: 'ON・OFF 機能のみ',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。`,
          priceName: `送信機 電圧入力型（F-306)
          カラー：グレー`,
          listPrice: 15000,
          regularPrice: 10500,
        },
        {
          name: '電圧入力型送信機（２入力）',
          imagePath: '/static/products/fact-in-call/items/item_06.png',
          spec: {
            型式: 'F-306W',
            サイズ: `75（W）×36.9（D）×116（H）mm
            ホルダー装着時
            75.42（W）×42.1（D）×116.42（H）mm`,
            重量: `約 165g（単三アルカリ電池 ×2 本含む。
            ホルダー装着時は約 190g）`,
            電源: `単三アルカリ電池 ×2 本
            DC3.3V 専用アダプター（別売）`,
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1 ～ FF',
            表示色設定: '色分け可能',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。`,
          priceName: `送信機 電圧入力型 2 ボタン
          （F-306W)
          カラー：グレー`,
          listPrice: 18000,
          regularPrice: 12600,
        },
        {
          name: '卓上丸型送信機',
          imagePath: '/static/products/fact-in-call/items/item_07.png',
          spec: {
            型式: 'F-305',
            サイズ: '80（W）×80（D）×43（H）mm',
            重量: '約 130g（単三アルカリ電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1 ～ FF',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: `送信機 丸型 1 ボタン（F-305)`,
          listPrice: 12000,
          regularPrice: 8400,
        },
        {
          name: '卓上丸型送信機 ナプキンスタンド型',
          imagePath: '/static/products/fact-in-call/items/item_08.png',
          spec: {
            型式: 'F-305N',
            サイズ: '99（W）×129（D）×99（H）mm',
            重量: '約 260g（単三アルカリ電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1 ～ FF',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: `送信機 丸型ナプキン付 1 ボタン
          （F-305N)`,
          listPrice: 15000,
          regularPrice: 10500,
        },
        {
          name: 'スタンダード型送信機',
          imagePath: '/static/products/fact-in-call/items/item_09.png',
          imageHeight: 300,
          spec: {
            型式: 'F-301',
            サイズ: '85（W）×78（D）×71（H）mm',
            重量: '約 150g（単三アルカリ電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1～FF',
            表示色設定: '各ボタン 3 色',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: ``,
          listPrice: 0,
          regularPrice: 0,
        },
        {
          name: 'スタンダード型送信機',
          imagePath: '/static/products/fact-in-call/items/item_14.png',
          priceName: `送信機 スタンダード型 2 ボタン
          （F-301)
          カラー：ブラウンアッシュ、
          メタリック、アイボリー`,
          listPrice: 12000,
          regularPrice: 8400,
        },
        {
          name: 'ナプキンスタンド型送信機',
          imagePath: '/static/products/fact-in-call/items/item_10.png',
          imageHeight: 300,
          spec: {
            型式: 'F-303',
            サイズ: '99（W）×120（D）×111（H）mm',
            重量: '約 240g（単三アルカリ電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1～FF',
            表示色設定: '各ボタン 3 色',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: ``,
          listPrice: 0,
          regularPrice: 0,
        },
        {
          name: 'ナプキンスタンド型送信機',
          imagePath: '/static/products/fact-in-call/items/item_15.png',
          priceName: `送信機 ナプキンスタンド型
          2 ボタン（F-303)
          カラー：ブラウンアッシュ、
          メタリック、アイボリー`,
          listPrice: 15000,
          regularPrice: 10500,
        },
        {
          name: 'カード型送信機',
          imagePath: '/static/products/fact-in-call/items/item_11.png',
          imageHeight: 300,
          spec: {
            型式: 'F-302',
            サイズ: `55（W）×93（D）×11（H）mm
            （ホルダー装着時は 60(W)x98(D)x15(H)mm）`,
            重量: `約 35g（アルカリボタン電池 ×2 個含む。
            ホルダー装着時は約 55g）`,
            電源: 'アルカリボタン電池 LR44×2 個',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1～FF',
            表示色設定: '各ボタン 3 色',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: ``,
          listPrice: 0,
          regularPrice: 0,
        },
        {
          name: 'カード型送信機',
          imagePath: '/static/products/fact-in-call/items/item_16.png',
          priceName: `送信機 カード型ホルダー付
          2 ボタン（F-302)
          カラー：ブラウンアッシュ、
          メタリック、アイボリー`,
          listPrice: 12000,
          regularPrice: 8400,
        },
        {
          name: '中継機',
          imagePath: '/static/products/fact-in-call/items/item_12.png',
          spec: {
            型式: 'F-500',
            サイズ: `170（W）×85（D）×40（H）mm
            （アンテナ部含まず）`,
            重量: '約 200g',
            電源: 'DC6V 専用アダプター',
            送受信周波数: '426.025MHz ～（特定小電力）',
            送受信方式: '単信方式',
            送信出力: '1mW',
            チャンネル: '1 ～ 15 チャンネル',
            中継機番号設定: '1 ～ 15',
            使用温度: '0℃～ 40℃',
          },
          priceName: `中継機（F-500）`,
          listPrice: 30000,
          regularPrice: 21000,
        },
        {
          name: '受信スピーカー',
          imagePath: '/static/products/fact-in-call/items/item_13.png',
          spec: {
            型式: 'F-600',
            サイズ: `166（W）×82（D）×42（H）mm
            （アンテナ部含まず）`,
            重量: '約 225g',
            電源: 'DC6V 専用アダプター',
            送受信周波数: '426.025MHz ～（特定小電力）',
            送受信方式: '単信方式',
            受信距離: '約 100m（使用環境により変わります）',
            鳴動回数設定: 'ディップスイッチにて 8 種類',
            音量調節: '回転式ボリューム（無段階）',
            スピーカー出力: '300mW',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          priceName: `受信スピーカー（F-600）`,
          listPrice: 30000,
          regularPrice: 21000,
        },
      ],
      catalogues: [
        {
          id: 1,
          name: 'ファクトインコール工場',
          imagePath:
            '/static/products/fact-in-call/catalogues/catalogue_01.jpg',
          downloadUri:
            '/static/products/fact-in-call/catalogues/catalogue_04.pdf',
          pageCount: 6,
          fileType: 'PDF',
          fileSize: '約 1.5MB',
        },
        {
          id: 2,
          name: 'ファクトインコール汎用',
          imagePath:
            '/static/products/fact-in-call/catalogues/catalogue_02.jpg',
          downloadUri:
            '/static/products/fact-in-call/catalogues/catalogue_02.pdf',
          pageCount: 4,
          fileType: 'PDF',
          fileSize: '約 4MB',
        },
        {
          id: 3,
          name: 'ファクトインコール汎用 取り扱い説明書',
          imagePath:
            '/static/products/fact-in-call/catalogues/catalogue_03.jpg',
          downloadUri:
            '/static/products/fact-in-call/catalogues/catalogue_05.pdf',
          pageCount: 30,
          fileType: 'PDF',
          fileSize: '約 6.7MB',
        },
      ],
      appDownloadUrl: 'https://echo5555.co.jp/products/fact_appli.php',
    }
  },
}
</script>

<style scoped>
.feature-top h2 {
  margin-top: 50px;

  color: rgb(16, 106, 203);
}

.feature-top .feature-contents {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.sp-product .feature-top .feature-contents {
  justify-content: center;
}

.feature-top .feature-contents .feature-content {
  position: static;

  width: 45%;
  margin: 0 0 50px;
}

.sp-product .feature-top .feature-contents .feature-content {
  width: 100%;
  max-width: 400px;
  margin-bottom: 10px;
}

.feature-top .feature-contents.features .feature-content .content-header {
  font-size: 18px;
}

.feature-content h4 {
  margin: 15px 0 10px;

  color: rgb(16, 106, 203);
}

.feature-top .feature-contents.features .feature-content img {
  position: static;

  width: 100%;
  height: auto;

  border: 1px solid rgb(16, 106, 203);
}

.feature-section .header h3 {
  color: rgb(16, 106, 203);
  font-size: 1.5em;
}

.use-scene {
  padding-bottom: 50px;

  background: rgb(228, 242, 254);
}

.use-scene .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  width: 90%;
  max-width: 1100px;
  margin: 0 auto;

  text-align: left;
}

.sp-product .use-scene .body {
  justify-content: center;
}

.use-scene .body .use-scene-block {
  width: 45%;
  margin-bottom: 30px;
}

.sp-product .use-scene .body .use-scene-block {
  width: 100%;
  max-width: 400px;
}

.use-scene .body .use-scene-block img {
  width: 100%;
  height: auto;
}

.use-scene .body .use-scene-block h4 {
  margin: 0;
}

.use-scene .body .use-scene-block p {
  font-size: 14px;
}

.feature-middle .feature-contents {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}

.feature-middle .feature-contents .feature-content img {
  top: 0;

  width: 20%;
  height: auto;
}

.feature-section .solution-example {
  background: linear-gradient(rgb(228, 236, 243), white);
}

.solution-example .body {
  width: 90%;
  max-width: 1100px;
  margin: 10px auto;
}

.feature-section .solution-example img {
  width: 22%;

  cursor: pointer;
}

.sp-product .feature-section .solution-example img {
  width: 40%;
  margin: 10px;

  cursor: pointer;
}

.feature-section .solution-example img + img {
  margin-left: 10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.main-function .body {
  width: 90%;

  background-color: rgb(242, 246, 250);
}

.feature-section
  .main-function
  .body
  .product-block
  .product-block-header
  .product-genre {
  width: 100%;
  margin-bottom: 10px;
  padding: 3px 0;
}

.product-tips {
  display: flex;
  justify-content: space-between;
}

.sp-product .product-tips {
  justify-content: center;
}

.product-tips .product-tip {
  display: inline-block;

  width: 200px;
  margin: 20px 5px 0;
}

.product-tips .product-tip img {
  width: 100%;
  height: auto;
}

.product-tips .product-tip p {
  font-size: 12px;

  margin: 0;
}

.worries-column .use-scene-block .use-scene-block-header {
  border-left: 4px solid rgb(16, 106, 203);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/FactInCall.vue